<template>
  <section>
    <v-card
      elevation="1"
      color="#FFF"
    >
      <v-card-text class="justify-center">
        <p class="process-header">
          Questions & Answers
        </p>
        <div
          v-if="!isQuestionsAvailable"
          class="empty-alert-div"
        >
          <br>
          <br>
          <p class="empty-alert-msg">
            <v-icon
              size="25"
              color="#C62828"
            >
              mdi-information-outline
            </v-icon>
            No questions found. <br> Please click on the next button for continuing the process.
          </p>
          <br>
        </div>
        <v-form>
          <div
            v-for="(item, i) in questions"
            :key="item.id"
          >
            <p class="title-text-style">
              Question - {{ i + 1 }}
            </p>
            <p class="question-style">
              {{ item.question }}
            </p>
            <div
              v-for="(answer, ansindex) in item.answers"
              :key="`answer - ${ansindex}`"
              class="answer-div"
            >
              <v-checkbox
                v-model="answerSelected[item.id]"
                :value="answer.answer"
                hide-details
                dense
                filled
                color="#FF3700"
                light
                outlined
              >
                <template #label>
                  <span class="input__label">{{ answer.answer }}</span>
                </template>
              </v-checkbox>
            </div>
            <hr>
            <br>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
    <v-btn
      color="#000"
      class="mt-5 btn-style"
      elevation="0"
      @click="questionsAnswered()"
    >
      Next
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>
<script>
  import spinner from 'src/views/components/SpinnerCentre';
  import Constants from 'src/constants';

  export default {
    name: 'StaffQandA',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        loading: false,
        cardBgImg: require('@/assets/img/cardBg.png'),
        answerSelected: {},
      };
    },
    computed: {
      questions () {
        return this.$store.getters['questions/getOrgQuestions'];
      },
      isQuestionsAvailable () {
        if (this.questions.length > 0) {
          return true;
        }
        return false;
      },
      selectedOrganization () {
        return this.$store.getters['organization/getSelectedOrganization'];
      },
    },
    async mounted () {
      this.loading = true;
      await this.fetchOrgQuestions();
      this.loading = false;
    },
    methods: {
      async fetchOrgQuestions () {
        await this.$store.dispatch('questions/fetchOrgQuestions', {
          userType: 'staff',
          organizationExtId: this.selectedOrganization.organization.external_id,
        });
      },
      async questionsAnswered () {
        if (this.questions.length !== Object.keys(this.answerSelected).length) {
          this.$store.dispatch('alert/onAlert', {
            message: 'All questions are mandatory.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        setTimeout(() => {
          this.$store.dispatch('questions/onAddUserSelectedAnswers', this.answerSelected);
          this.loading = false;
          this.$emit('questions-answered');
        }, 1000);
      },
      cancel () {
        this.loading = true;
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
        setTimeout(() => {
          this.$router.push({ name: 'CheckIn' });
        }, 1000);
      },
    },
  };
  </script>
  <style scoped>
  .question-style {
  color: black;
  font-size: 17px;
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
}
.answer-div {
  margin-bottom: 10px;
  margin-top: -10px;
}
.input__label {
  font-weight: bold;
  font-size: 17px;
  font-family: 'Times New Roman', Times, serif;
  color: black;
}
::v-deep .v-input--selection-controls__input .v-icon {
  color: #37474F !important;
}
</style>
